import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/unsubscribe")({
  component: Unsubscribe,
  head: () => ({
    meta: [
      { title: "Cancelar subscrição | InvestCapital" },
      {
        name: "description",
        content: "Cancele o envio de emails da InvestCapital para o seu endereço.",
      },
      { property: "og:title", content: "Cancelar subscrição | InvestCapital" },
      {
        property: "og:description",
        content: "Cancele o envio de emails da InvestCapital para o seu endereço.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
});

type State = "loading" | "valid" | "already" | "invalid" | "done" | "error";

function Unsubscribe() {
  const [state, setState] = useState<State>("loading");
  const [busy, setBusy] = useState(false);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("token");
    setToken(t);
    if (!t) {
      setState("invalid");
      return;
    }
    fetch(`/email/unsubscribe?token=${encodeURIComponent(t)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) return setState("invalid");
        if (data.valid) return setState("valid");
        if (data.reason === "already_unsubscribed") return setState("already");
        setState("invalid");
      })
      .catch(() => setState("error"));
  }, []);

  async function confirm() {
    if (!token) return;
    setBusy(true);
    const r = await fetch("/email/unsubscribe", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ token }),
    }).catch(() => null);
    setBusy(false);
    setState(r && r.ok ? "done" : "error");
  }

  return (
    <main className="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center px-6 py-16 text-center">
      <h1 className="text-2xl font-semibold text-foreground">Cancelar subscrição</h1>
      <div className="mt-4 text-muted-foreground">
        {state === "loading" && <p>A validar o pedido…</p>}
        {state === "valid" && <p>Confirme que pretende deixar de receber os nossos emails.</p>}
        {state === "already" && <p>Este endereço já estava removido da nossa lista.</p>}
        {state === "invalid" && <p>Ligação inválida ou expirada.</p>}
        {state === "done" && <p>Subscrição cancelada. Não voltará a receber os nossos emails.</p>}
        {state === "error" && <p>Ocorreu um erro. Tente novamente mais tarde.</p>}
      </div>
      {state === "valid" && (
        <Button className="mt-6" onClick={confirm} disabled={busy}>
          {busy ? "A processar…" : "Confirmar cancelamento"}
        </Button>
      )}
    </main>
  );
}
